import Vue from 'vue'
import App from './App.vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vant from 'vant'
import 'vant/lib/index.css'

import router from './router'
import './assets/css/reset.scss'
import './assets/css/newicon.css'
import './assets/css/iconfont.css'

// import './assets/config/rem.js'
import 'lib-flexible'

/* 引入请求 */
import { getRequest } from "./api/request";
import { postRequest } from "./api/request";
import { putRequest } from "./api/request";
// import WechatPlugin from './utils/WechatPlugin'
// // 全局注册微信jsdk
// Vue.use(WechatPlugin)
import touch from 'vue-hand-mobile'
Vue.use(touch)
import store from "./store";
import plugins from './utils/plugins'
import { Toast } from 'vant';
Vue.use(Toast)
Vue.use(plugins)
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// 全局挂载
Vue.use(VueAwesomeSwiper)
Vue.prototype.postRequest = postRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.putRequest = putRequest;
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(Vant)
new Vue({
  router,store,
  render: h => h(App)
}).$mount('#app')
